import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AuthService} from "../_services/auth.service";
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {SnackbarService} from "../_services/snackbar.service";

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrl: './password-reset.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordResetComponent {
    councilLogo: string | undefined;
    authorityName: string | undefined;
    loading: boolean = false;
    passwordForm: FormGroup;
    token: string | undefined;
    passwordLength: number = 8;

    constructor(private readonly formBuilder: FormBuilder,
                private authService: AuthService,
                private route: ActivatedRoute,
                private readonly router: Router,
                private snackbarService: SnackbarService) {
        this.route.params
            .subscribe(params => {
                this.token = params['token'];
            }, error => {
                this.snackbarService.openSnackBar(error, 'error')
                console.error(error);
            });
        this.passwordForm = this.formBuilder.group({
            password: ['', this.passwordValidators(8)],
            confirmPassword: ['', this.passwordValidators(8)],
        }, {validators: this.passwordMatchValidator})

        this.authService.getDynamicSettings().then((r): void => {
            this.councilLogo = r.authority_logo;
            this.authorityName = r.authority_name;
            if (r.minimum_password_length) {
                this.passwordLength = r.minimum_password_length;
                this.passwordForm.controls['password'].setValidators(this.passwordValidators(this.passwordLength));
                this.passwordForm.controls['confirmPassword'].setValidators(this.passwordValidators(this.passwordLength));
                this.passwordForm.updateValueAndValidity();
            }
        });
    }

    resetPassword(): void {
        this.loading = true;
        let body = {
            token_id: this.token,
            password: this.passwordForm.value.password,
            password_confirm: this.passwordForm.value.confirmPassword
        }
        this.authService.resetPassword(body).subscribe({
            next: r => {
                this.loading = false;
                this.snackbarService.openSnackBar('Password reset successful', 'success')
                this.router.navigate(['/login']);
            }, error: error => {
                this.loading = false;
                this.snackbarService.openSnackBar(error, 'error')
                console.error(error)
            }
        });
    }

    private passwordValidators(length: number): ValidatorFn[] {
        const specialCharacters: string = `[!@#$%^&*()_+\\-=\\[\\]{};':"\\\\|,.<>\\/?]`;
        const pattern: string = `^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*${specialCharacters})(?!.*\\s).{${length},}$`;

        return [Validators.required, Validators.minLength(length), Validators.pattern(pattern)];
    }

    private passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
        const password: string | null = group.get('password')?.value;
        const confirmPassword: string | null = group.get('confirmPassword')?.value;

        return password === confirmPassword ? null : {passwordMismatch: true};
    }
}
